import React, { useState } from "react";
import {
  InputMain,
  CustomInput,
  CustomLabel,
  ErrorSpan,
  PasswordIcon,
} from "./InpusStyles";

const AuthInput = ({
  inputMoreText,
  field,
  form,
  label,
  placeholder = "",
  haveMoreText = false,
  nolabel = false,
  showIcon = false,
  ...props
}) => {
  const id = props.id || props.name;
  const error = form.touched[field.name] && form.errors[field.name];

  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <InputMain className="AuthInputMain">
        <CustomLabel htmlFor={id}>{label}</CustomLabel>
        <CustomInput
          {...field}
          {...props}
          error={error}
          placeholder={placeholder}
          className={`${haveMoreText ? "has_more_text" : ""}${
            nolabel ? " no_label" : ""
          }`}
          type={showPassword ? "text" : props.type}
          autoComplete="off"
        />
        {inputMoreText && (
          <span className="inputMoreText">{inputMoreText}</span>
        )}
        {error && <ErrorSpan>{form.errors[field.name]}</ErrorSpan>}
        {showIcon && props.type === "password" && (
          <PasswordIcon
            visible={!showPassword}
            onClick={handleTogglePassword}
          />
        )}
      </InputMain>
    </>
  );
};

export default AuthInput;
